import Vue from "vue";
import VueCookies from "vue-cookies";

import { LocalizationPlugin } from "@/plugins/localization";
import { AxiosPlugin } from "@/plugins/axios";

Vue.use(VueCookies);
Vue.use(LocalizationPlugin);
Vue.use(AxiosPlugin);

export default {

};
